export const Footer = {
	availableLinks: []
};
